import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapService } from './map.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [MapService],
})
export class MapModule {}
